import { ID } from './id';

export enum TaskActionType {
  GoalTimeslot = 'goal-timeslot',
  LifeAreaTimeslot = 'life-area-timeslot',
}

export type TaskActionGoal = {
  type: TaskActionType.GoalTimeslot;
  meta: { id: ID };
};

export type TaskActionLifeArea = {
  type: TaskActionType.LifeAreaTimeslot;
  meta: { id: ID };
};

// Generic TaskAction type as a union of specific action types
export type TaskAction = TaskActionGoal | TaskActionLifeArea;
